<div class="service-catalog-page">
  <div class="card carddborder service-catalog-header">
    <div class="card-header">
      <div class="launch-header d-flex w-100 justify-content-between">
        <h5 class="mb-0">Service Catalog</h5>
        <div class="service-picker">
          <label for="serviceType" class="service-picker-label mb-0">Service:</label>
          <ng-select
            id="serviceType"
            class="service-picker-select"
            [(ngModel)]="selectedService"
            [searchable]="false"
            [clearable]="false"
          >
            <ng-option value="ec2">EC2</ng-option>
            <ng-option value="eks">EKS</ng-option>
          </ng-select>
        </div>
      </div>
    </div>
  </div>

  <app-ec2-dashboard *ngIf="selectedService === 'ec2'" [preserveServiceCatalogHeader]="true"></app-ec2-dashboard>
  <app-eks-dashboard *ngIf="selectedService === 'eks'" [preserveServiceCatalogHeader]="true"></app-eks-dashboard>
</div>
